'use strict';

var React = require('react');
var FullWidthButton$1 = require('@swiggy-private/dls-web-core/dist/components/FullWidthButton');
var index_es = require('./index.es-8c72aff8.js');
var WidgetControllerContext = require('./WidgetControllerContext-924d4968.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const defaultAttributes = {
    variant: "primary",
};
const FullWidthButtonComp = ({ text, clickAction, attrs = defaultAttributes, analytics, accessibility, position, containerStyle = {}, }) => {
    const { impressionAnalytics, clickAnalytics, sdk } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    React.useEffect(() => {
        if (!index_es.N(analytics)) {
            if (!index_es.N(analytics.impressionObjectName) && !index_es.N(impressionAnalytics)) {
                impressionAnalytics({
                    action: analytics.impressionObjectName,
                    category: analytics.screenName,
                    label: analytics.objectValue,
                    value: position,
                    context: analytics.context,
                });
            }
        }
    }, [impressionAnalytics, analytics, position]);
    const clickHandler = React.useCallback(() => {
        if (!sdk || !clickAction)
            return;
        if (!index_es.N(analytics)) {
            if (!index_es.N(analytics.clickObjectName) && !index_es.N(clickAnalytics)) {
                clickAnalytics({
                    action: analytics.clickObjectName,
                    category: analytics.screenName,
                    label: analytics.objectValue,
                    value: position,
                    context: analytics.context,
                });
            }
        }
        sdk[clickAction.name](clickAction.params);
    }, [clickAnalytics, analytics, sdk, clickAction, position]);
    return (React__default['default'].createElement("div", { style: containerStyle },
        React__default['default'].createElement(FullWidthButton$1.FullWidthButton, Object.assign({ "aria-label": accessibility === null || accessibility === void 0 ? void 0 : accessibility.altText, onClick: clickHandler, "data-testid": "click-full-width-button" }, attrs), text)));
};
var FullWidthButton = React__default['default'].memo(FullWidthButtonComp);

exports.FullWidthButton = FullWidthButton;
//# sourceMappingURL=FullWidthButton-fcaa6f2d.js.map
